<script lang="ts">
  export let size: "small" | "medium" | "large" = "small";
  let className: string | undefined | null = undefined;
  export { className as class };

</script>

<p
  data-testid="featured-label"
  class={className + ` fizz-text-subdued`}
  class:fizz-text-small={size === "small"}
  class:fizz-text-medium={size === "medium"}
  class:fizz-text-large={size === "large"}
  {...$$restProps}
>
  Sponsored
</p>
